import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { PAGE_QUERY_PARAM } from '../../../../shared/constants/commonConstants';
import { extractSecondLevelBaseUrl } from '../../../../utils/utility';
import LabTestForm from './LabTestForm';

const EditLabTestPackage = ({ match: { path, params: { testId, groupId } } }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  return (
    <div>
      <PageHeader
        backUrl={extractSecondLevelBaseUrl(path) + '/lab-tests' + PAGE_QUERY_PARAM + (pageNumber ? pageNumber : 1)}
        pageTitle="Edit Lab Tests"

      />
      <div className="ant-tabs-content-holder tab-custom-container">
        <LabTestForm groupId={groupId} packageId={testId} />
      </div>
    </div>
  );
};

export default EditLabTestPackage;
